module.exports = __webpack_public_path__ + "img/map-0.808d4329.svg";